import serverCall from "../../serverCall";

const getAllUser = async (search, page, limit) => {
  const response = await serverCall.get(
    `user/find-all-detail/admin?search=${search}&page=${page}&limit=${limit}`
  );
  return response;
};
const getAllUserList = async () => {
  const response = await serverCall.get(`user/find-all-detail/admin`);
  return response;
};

const GetSingleUserData = async (id) => {
  const response = await serverCall.get(
    `/user/find-one-detail/admin?userId=${id}`
  );
  return response;
};
const UserDelete = async (id) => {
  const response = await serverCall.delete(
    `/user/delete-account/admin?userId=${id}`
  );
  return response;
};
const UserUpdate = async (data) => {
  const response = await serverCall.put(`/user/update-user-detail/admin`, data);
  return response;
};
const AddUser = async (data) => {
  const response = await serverCall.post(`/user/create-user/admin`, data);
  return response;
};
const GetUser = async (id) => {
  const response = await serverCall.get(
    `/user/find-one-user/admin?userId=${id}`
  );
  return response;
};

const UserService = {
  getAllUser,
  GetSingleUserData,
  UserDelete,
  GetUser,
  UserUpdate,
  getAllUserList,
  AddUser,
};

export default UserService;
